// src/context/AuthContext.jsx
import React, { createContext, useState, useContext, useEffect } from "react";
import { authAPI } from "../services/api";

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");

    if (token && savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (err) {
        console.error("Error parsing user:", err);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    }
    setLoading(false);
  }, []);

 const login = async (email, password) => {
  try {
    setLoading(true);

    const result = await authAPI.login(email, password);

    if (result.success) {
      const token = result.data.token;
      const userData = result.data.user;

      if (token) {
        localStorage.setItem("token", token);
      }

      if (userData) {
        localStorage.setItem("user", JSON.stringify(userData));
        setUser(userData);
      }

      setIsAuthenticated(true);
      return { success: true };
    }

    return { success: false, error: result.error };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Login failed",
    };
  } finally {
    setLoading(false);
  }
};


const register = async (name, email, password) => {
  try {
    const result = await authAPI.register(name, email, password);

    if (!result.success) {
      return { success: false, error: result.error };
    }

    // Backend returns token + user or not?
    const token = result.data.token;
    const userData = result.data.user;

    if (token) localStorage.setItem("token", token);
    if (userData) {
      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);
    }

    setIsAuthenticated(true);
    return { success: true };
  } catch (err) {
    return { success: false, error: "Something went wrong" };
  }
};
  const logout = async () => {
    try {
      await authAPI.logout();
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  const value = {
    user,
    isAuthenticated,
    loading,
    login,
    register,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
